export const AUTH_STORAGE_KEYS = {
  session: 'auth.session',
  rememberMe: 'auth.rememberMe'
} as const;
